export default {
  clients: {
    title:
      'A solid company, with a <span class="font-bold">long track record and wide experience</span> with market benchmark companies in several segments.',
  },
}
